import { getAccount, refreshToken } from "./commonService";
import { navigateToSessionExpired, navigateToError } from "./navigationService";
import { checkOutageWindow } from "./outageMonitor";


const apiList = [
  "/api/Insights/GetApplicationData",
  "/User/update/Acknowledged",
  "/api/partners/utilitydata",
  "/api/partners/editEngagementDetails",
  "/api/partners/AccessGrant",
  "/api/partners/AccessRevoke",
  "/User/LoginUser"
];

export const BASE_URL = process.env.REACT_APP_API_URL;

const extractPath = (url) => {
  try {
    const parsedUrl = new URL(url, BASE_URL);
    return parsedUrl.pathname;
  } catch {
    return url;
  }
};

export const axiosInstanceConfig = (axiosInstance) => {
  const onRequest = async (config) => {
    try {
      const account = getAccount();
      if (!account) throw new Error("SessionExpired");

      config.headers["Authorization"] = `Bearer ${account.idToken}`;
    } catch (error) {
      if (error.message === "SessionExpired") {
        navigateToSessionExpired();
      }
    }
    return config;
  };

  const onRequestError = (error) => Promise.reject(error);

  const onResponse = (response) => {
    checkOutageWindow();
    return response;
  };

  const onResponseError = async (error) => {
    checkOutageWindow();
    const requestPath = extractPath(error.config?.url);
    const isMatchingApi = apiList.some((api) => requestPath.includes(api));
    const isTooManyRequests = error.response?.status === 429;

    if (error.response?.status === 401 && !error.config._retry) {
      error.config._retry = true;

      try {
        const token = await refreshToken();
        error.config.headers["Authorization"] = `Bearer ${token}`;
        return axiosInstance(error.config);
      } catch (refreshError) {
        if (refreshError.message === "SessionExpired") {
          navigateToSessionExpired();
          return;
        }
      }
    }

    if (isMatchingApi && !isTooManyRequests) {
      navigateToError();
    }

    return Promise.reject(error);
  };

  axiosInstance.interceptors.request.use(onRequest, onRequestError);
  axiosInstance.interceptors.response.use(onResponse, onResponseError);

  return axiosInstance;
};